// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Signika+Negative:300,400,600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@use './styles';

/* Please define all colors in rgb format so any 
transparency effects can be applied via a uniform 
string replace operation in code */

/* Please define all times in seconds to any transition
effects can be applied via a uniform string replace
operation in code */

:root {
  --tp-base-font-family: "Montserrat", sans-serif !important;
  --color-bg: rgb(252, 252, 252);
  --color-fg: rgb(0, 0, 0);
  --color-hover: rgb(179, 30, 0);
  --blur-background: blur(10px);
  --transition-time: 0.5s;
  --padding: 1rem;
  --offset: 20vw;
  --button-bg: rgb(131, 12, 0);
  --button-fg: rgba(255, 255, 255);
  --border-color: rgba(255, 255, 255);
  --button-border-color: rgba(255, 255, 255, 0.40);
  --badge-bg-color:  rgb(131, 12, 0);
  --badge-fg-color:  rgb(0,0,0);
  --color-fg-opacity: rgba(0, 0, 0, 0.4);
  --badge-fg-color:  rgba(255, 255, 255);
  --color-bg-opacity: rgba(252, 252, 252, 0.2);
}

[data-theme="light"] {
  --color-bg: rgb(252, 252, 252);
  --color-fg: rgb(0, 0, 0);
  --color-fg-opacity: rgba(0, 0, 0, 0.3);
  --color-bg-opacity: rgba(0, 0, 0, 0.1);
  --color-hover: rgb(179, 30, 0);
  --border-color: rgba(0, 0, 0, 0.40);
}

[data-theme="dark"] {
  --color-bg: rgb(18, 18, 18);
  --color-fg: rgb(252, 252, 252);
  --color-fg-opacity: rgba(252, 252, 252, 0.2);
  --color-bg-opacity: rgba(0, 0, 0, 0.3);
  --color-hover: rgb(163, 65, 45);
  --border-color: rgba(255, 255, 255, 0.50);
}

html {
  scroll-behavior: smooth;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: "Signika Negative", sans-serif, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--color-bg);
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

body.hidePanel .TileManager .TileManager,
body.hidePanel .TileManager .TileManager .slider {
  visibility: hidden !important;
  height: 0px !important;
  padding: 0px !important;
}

body.hidePanel .Header,
body.hidePanel .tile-manager-title,
body.hidePanel .Footer {
  display: none !important;
}

h3 {
  font-family: "Montserrat", sans-serif;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* ContentTile styles */

.ContentTile_ {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    width: 70%;
    text-align: center;
  }

  h1,
  span {
    display: inline;
    flex-direction: row;
    justify-content: space-around;
    font-family: "Montserrat", sans-serif;

    @include styles.mobile {
      font-size: 2rem;
      line-height: 2.5rem;
    }

    @include styles.tablet {
      font-size: 2.5rem;
      line-height: 3rem;
    }

    @include styles.desktop {
      font-size: 3rem;
      line-height: 3.5rem;
    }
  }

  h2 {
    font-family: "Montserrat", sans-serif;

    @include styles.mobile {
      font-size: 1rem;
      line-height: 1.25rem;
    }

    @include styles.tablet {
      font-size: 2rem;
      line-height: 2.5rem;
    }

    @include styles.desktop {
      font-size: 2.25rem;
      line-height: 2.75rem;
    }

  }

  h3 {
    font-family: "Montserrat", sans-serif;
    font-size: 1.2rem;
  }

  hr {
    width: 70%;
    height: 1px;
    background-color: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.20);
  }

  em, em * {
    color: #830C00;
    font-style: normal;
  }

  p {
    display: block;
    text-align: center;
    width: 80%;

    @include styles.mobile {
      font-size: 1rem;
    }

    @include styles.tablet {
      font-size: 1.1rem;
    }

    @include styles.desktop {
      font-size: 1.25rem;
    }
  }
  section {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    padding: 1rem;
    @include styles.mobile {
      flex-direction: column;
    }
  }

  small {
    font-size: 0.8rem;
    color: var(--color-fg-opacity);
  }

  video {
    object-fit: cover;
  }
}

/*Videos Tile container styles*/

.video__section {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.video__section  .VideoTile {
  margin: 0;
}

.video__container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 2rem;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.video__section--content {
  margin: 1rem;
}

@media only screen and (max-width: 600px) {
  .video__container {
    grid-template-columns: 1fr;
    padding: 1rem;
  }

  .video__container .content-container .content-headline {
    font-size: 2rem;
  }
}

/* These styles are for Text to motion tile*/
.text-to-motion-sample-slide {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 2rem;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.text-to-motion-sample-slide .image-container img {
  width: 100%;
}

.text-to-motion-sample-slide .content-container {
  width: 100%;
  align-items: flex-start;
  text-align: left;
}

.text-to-motion-sample-slide .content-container .content-headline {
  font-size: 3rem;
  align-items: flex-start;
}

.text-to-motion-sample-slide .content-container .content-description {
  align-items: flex-start;
  text-align: left;
}


@media only screen and (max-width: 600px) {
  .text-to-motion-sample-slide {
    grid-template-columns: 1fr;
    padding: 1rem;
  }

  .text-to-motion-sample-slide .content-container .content-headline {
    font-size: 2rem;
  }
}

/*These styles are for For Developer Tile set*/

.tile-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.tile-content .tile-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: .5rem;
  font-size: 1.8rem;
}

.tile-content .tile-head i {
  font-size: 5rem;
}

.tile-content .tile-head div:last-child {
  font-size: 1rem;
}

.tile-content .tile-lable {
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 700;
}

/*These styles are for Contact Tile set*/

.contact-section {
  display: flex;
  padding: 1.5rem 0;
  gap: 1rem;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
}

.contact-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;
  height: 100%;
  gap: 1rem;
}

.contact-container .tile-content, 
.contact-container .tile-head {
  align-items: start;
}

.tile-content .tile-head h3 {
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 700;
  text-align: left;
  margin: 0;
}

.tile-content .tile-lable p {
  font-size: 1rem;
  font-weight: normal;
  text-align: left;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA,eAAe;;AAKf;;kCAEkC;;AAElC;;mBAEmB;;AAEnB;EACE,0DAA0D;EAC1D,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,gCAAgC;EAChC,mCAAmC;EACnC,gDAAgD;EAChD,kCAAkC;EAClC,6BAA6B;EAC7B,sCAAsC;EACtC,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,sCAAsC;EACtC,sCAAsC;EACtC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,4CAA4C;EAC5C,sCAAsC;EACtC,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kDAAkD;EAClD,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,+EAA+E;AACjF;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,qCAAqC;;IAErC;MACE,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,mBAAmB;IACrB;EACF;;EAEA;IACE,qCAAqC;;IAErC;MACE,eAAe;MACf,oBAAoB;IACtB;;IAEA;MACE,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,oBAAoB;IACtB;;EAEF;;EAEA;IACE,qCAAqC;IACrC,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,4CAA4C;EAC9C;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,UAAU;;IAEV;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;EACF;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;;AAGA;EACE;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,8CAA8C;;AAE9C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wCAAwC;;AAExC;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX","sourcesContent":["@use './styles';\n\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Signika+Negative:300,400,600&display=swap');\n\n/* Please define all colors in rgb format so any \ntransparency effects can be applied via a uniform \nstring replace operation in code */\n\n/* Please define all times in seconds to any transition\neffects can be applied via a uniform string replace\noperation in code */\n\n:root {\n  --tp-base-font-family: \"Montserrat\", sans-serif !important;\n  --color-bg: rgb(252, 252, 252);\n  --color-fg: rgb(0, 0, 0);\n  --color-hover: rgb(179, 30, 0);\n  --blur-background: blur(10px);\n  --transition-time: 0.5s;\n  --padding: 1rem;\n  --offset: 20vw;\n  --button-bg: rgb(131, 12, 0);\n  --button-fg: rgba(255, 255, 255);\n  --border-color: rgba(255, 255, 255);\n  --button-border-color: rgba(255, 255, 255, 0.40);\n  --badge-bg-color:  rgb(131, 12, 0);\n  --badge-fg-color:  rgb(0,0,0);\n  --color-fg-opacity: rgba(0, 0, 0, 0.4);\n  --badge-fg-color:  rgba(255, 255, 255);\n  --color-bg-opacity: rgba(252, 252, 252, 0.2);\n}\n\n[data-theme=\"light\"] {\n  --color-bg: rgb(252, 252, 252);\n  --color-fg: rgb(0, 0, 0);\n  --color-fg-opacity: rgba(0, 0, 0, 0.3);\n  --color-bg-opacity: rgba(0, 0, 0, 0.1);\n  --color-hover: rgb(179, 30, 0);\n  --border-color: rgba(0, 0, 0, 0.40);\n}\n\n[data-theme=\"dark\"] {\n  --color-bg: rgb(18, 18, 18);\n  --color-fg: rgb(252, 252, 252);\n  --color-fg-opacity: rgba(252, 252, 252, 0.2);\n  --color-bg-opacity: rgba(0, 0, 0, 0.3);\n  --color-hover: rgb(163, 65, 45);\n  --border-color: rgba(255, 255, 255, 0.50);\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Signika Negative\", sans-serif, Arial;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--color-bg);\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\nbody.hidePanel .TileManager .TileManager,\nbody.hidePanel .TileManager .TileManager .slider {\n  visibility: hidden !important;\n  height: 0px !important;\n  padding: 0px !important;\n}\n\nbody.hidePanel .Header,\nbody.hidePanel .tile-manager-title,\nbody.hidePanel .Footer {\n  display: none !important;\n}\n\nh3 {\n  font-family: \"Montserrat\", sans-serif;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* ContentTile styles */\n\n.ContentTile_ {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  h1 {\n    width: 70%;\n    text-align: center;\n  }\n\n  h1,\n  span {\n    display: inline;\n    flex-direction: row;\n    justify-content: space-around;\n    font-family: \"Montserrat\", sans-serif;\n\n    @include styles.mobile {\n      font-size: 2rem;\n      line-height: 2.5rem;\n    }\n\n    @include styles.tablet {\n      font-size: 2.5rem;\n      line-height: 3rem;\n    }\n\n    @include styles.desktop {\n      font-size: 3rem;\n      line-height: 3.5rem;\n    }\n  }\n\n  h2 {\n    font-family: \"Montserrat\", sans-serif;\n\n    @include styles.mobile {\n      font-size: 1rem;\n      line-height: 1.25rem;\n    }\n\n    @include styles.tablet {\n      font-size: 2rem;\n      line-height: 2.5rem;\n    }\n\n    @include styles.desktop {\n      font-size: 2.25rem;\n      line-height: 2.75rem;\n    }\n\n  }\n\n  h3 {\n    font-family: \"Montserrat\", sans-serif;\n    font-size: 1.2rem;\n  }\n\n  hr {\n    width: 70%;\n    height: 1px;\n    background-color: none;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.20);\n  }\n\n  em, em * {\n    color: #830C00;\n    font-style: normal;\n  }\n\n  p {\n    display: block;\n    text-align: center;\n    width: 80%;\n\n    @include styles.mobile {\n      font-size: 1rem;\n    }\n\n    @include styles.tablet {\n      font-size: 1.1rem;\n    }\n\n    @include styles.desktop {\n      font-size: 1.25rem;\n    }\n  }\n  section {\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    padding: 1rem;\n    @include styles.mobile {\n      flex-direction: column;\n    }\n  }\n\n  small {\n    font-size: 0.8rem;\n    color: var(--color-fg-opacity);\n  }\n\n  video {\n    object-fit: cover;\n  }\n}\n\n/*Videos Tile container styles*/\n\n.video__section {\n  display: flex;\n  gap: 1rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.video__section  .VideoTile {\n  margin: 0;\n}\n\n.video__container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  padding: 2rem;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.video__section--content {\n  margin: 1rem;\n}\n\n@media only screen and (max-width: 600px) {\n  .video__container {\n    grid-template-columns: 1fr;\n    padding: 1rem;\n  }\n\n  .video__container .content-container .content-headline {\n    font-size: 2rem;\n  }\n}\n\n/* These styles are for Text to motion tile*/\n.text-to-motion-sample-slide {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  padding: 2rem;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.text-to-motion-sample-slide .image-container img {\n  width: 100%;\n}\n\n.text-to-motion-sample-slide .content-container {\n  width: 100%;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.text-to-motion-sample-slide .content-container .content-headline {\n  font-size: 3rem;\n  align-items: flex-start;\n}\n\n.text-to-motion-sample-slide .content-container .content-description {\n  align-items: flex-start;\n  text-align: left;\n}\n\n\n@media only screen and (max-width: 600px) {\n  .text-to-motion-sample-slide {\n    grid-template-columns: 1fr;\n    padding: 1rem;\n  }\n\n  .text-to-motion-sample-slide .content-container .content-headline {\n    font-size: 2rem;\n  }\n}\n\n/*These styles are for For Developer Tile set*/\n\n.tile-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.tile-content .tile-head {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: .5rem;\n  font-size: 1.8rem;\n}\n\n.tile-content .tile-head i {\n  font-size: 5rem;\n}\n\n.tile-content .tile-head div:last-child {\n  font-size: 1rem;\n}\n\n.tile-content .tile-lable {\n  font-size: 1.2rem;\n  font-style: normal;\n  font-weight: 700;\n}\n\n/*These styles are for Contact Tile set*/\n\n.contact-section {\n  display: flex;\n  padding: 1.5rem 0;\n  gap: 1rem;\n  @media only screen and (max-width: 600px) {\n    flex-direction: column;\n  }\n}\n\n.contact-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2rem;\n  height: 100%;\n  gap: 1rem;\n}\n\n.contact-container .tile-content, \n.contact-container .tile-head {\n  align-items: start;\n}\n\n.tile-content .tile-head h3 {\n  font-size: 1.2rem;\n  font-style: normal;\n  font-weight: 700;\n  text-align: left;\n  margin: 0;\n}\n\n.tile-content .tile-lable p {\n  font-size: 1rem;\n  font-weight: normal;\n  text-align: left;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
